import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ChangePlanCustom from '../../modules/ChangePlanCustom';

class InactiveSubscription extends Component {
    constructor() {
        super();

        this.urlParams = new URLSearchParams(window.location.search);

        this.isTrial = window.user_permissions?.subscription_status === 'trialing';

        this.excluded = this.urlParams.get('excluded') || '';
        this.isCancelling = this.urlParams.get('cancellation') || '';
        this.inactiveProduct = null;

        if (this.excluded === 'discover_analytics') {
            this.header = (
                <>
                    Your {this.isTrial ? 'trial ' : 'plan '}does not include{' '}
                    <strong>"DISCOVER ANALYTICS"</strong>, please add it to your plan.
                </>
            );
            this.inactiveProduct = 'google_discover_analytics';
        }

        if (this.excluded === 'search_analytics') {
            this.header = (
                <>
                    Your {this.isTrial ? 'trial ' : 'plan '}does not include{' '}
                    <strong>"SEARCH ANALYTICS"</strong>, please add it to your plan.
                </>
            );
            this.inactiveProduct = 'google_search_analytics';
        }

        if (this.excluded === 'ai_tracking') {
            this.header = (
                <>
                    Your {this.isTrial ? 'trial ' : 'plan '}does not include{' '}
                    <strong>"AI TRACKING"</strong>, please add it to your plan.
                </>
            );
            this.inactiveProduct = 'ai_tracking';
        }

        if (this.excluded === 'commerce') {
            this.header = (
                <>
                    Your {this.isTrial ? 'trial ' : 'plan '}does not include{' '}
                    <strong>"COMMERCE ANALYTICS"</strong>, please add it to your plan.
                </>
            );
            this.inactiveProduct = 'commerce';
        }
        if (this.isCancelling) {
            this.header =
                'Cancel your GDdash subscription? Or downgrade by removing select product below?';
        }
    }

    render() {
        return (
            <div className="inactive-subscription">
                <h2 className="page-title" style={{ fontWeight: '500' }}>
                    {this.header}
                </h2>
                <ChangePlanCustom inactiveProduct={this.inactiveProduct} />
            </div>
        );
    }
}

export default withTranslation()(InactiveSubscription);
